import React, { useEffect } from "react";
import { I } from "./icons";
import { useNav } from "./context/NavContext";
import type { AgentAlert, Lang, Translations, PrefetchFn } from "./types";

interface BottomNavProps {
  t: Translations;
  cartCnt: number;
  setCartOpen: (open: boolean) => void;
  agentAlerts: AgentAlert[];
  lang: Lang;
  prefetchDashboard?: PrefetchFn;
  prefetchProducts?: PrefetchFn;
}

export function BottomNav({ t, cartCnt, setCartOpen, agentAlerts, lang, prefetchDashboard, prefetchProducts }: BottomNavProps) {
  const { page, nav } = useNav();
  useEffect(() => {
    prefetchDashboard?.();
    prefetchProducts?.();
  }, [prefetchDashboard, prefetchProducts]);

  const alertCount = agentAlerts.filter((a) => !a.dismissed && a.priority === "high").length;
  const cartLabel = lang === "es" ? "Carrito" : "Cart";
  const agentLabel = "NutriCoach AI";

  const item = (
    id: string,
    icon: React.ReactNode,
    label: string,
    extra: React.ReactNode = null,
    onClick: () => void = () => nav(id),
    prefetch?: () => void
  ) => {
    const active = page === id;
    return (
      <button
        type="button"
        className={`bnav-i ${active ? "on" : ""}`}
        onClick={onClick}
        onMouseEnter={prefetch}
        onTouchStart={prefetch}
        aria-label={label}
        aria-current={active ? "page" : undefined}
      >
        <span className="bnav-ic" aria-hidden="true">{icon}</span>
        {extra}
        <span className="bnav-lb">{label}</span>
      </button>
    );
  };

  return (
    <nav className="bnav" aria-label={lang === "es" ? "Navegación principal" : "Primary navigation"}>
      {item("dashboard", I.home, t.dashboard, null, undefined, prefetchDashboard)}
      {item("products", I.grid, t.products, null, undefined, prefetchProducts)}
      {item("bodyScan", I.bodyScan, t.bodyScan)}
      <button
        type="button"
        className="bnav-i bnav-cart"
        onClick={() => setCartOpen(true)}
        aria-label={`${cartLabel}${cartCnt > 0 ? `, ${cartCnt} ${lang === "es" ? "artículos" : "items"}` : ""}`}
      >
        <span className="bnav-ic" aria-hidden="true">{I.cart}</span>
        {cartCnt > 0 && <span className="bnav-badge" aria-hidden="true">{cartCnt}</span>}
        <span className="bnav-lb">{cartLabel}</span>
      </button>
      
      {item(
        "nutricoach",
        I.cpu,
        agentLabel,
        alertCount > 0 ? <span className="bnav-alert" aria-hidden="true" /> : null
      )}
      {item("profile", I.user, t.profile)}
    </nav>
  );
}